import { Helmet } from "react-helmet-async";

const PROD_DOMAIN = "https://www.thesecretseller.co.uk";

const SEO_DATA = {
  "/": {
    title: "Virtual Staging & 3D Renders | The Secret Seller",
    description: "Transform empty properties into homes buyers can picture themselves living in. Virtual staging and 3D renders from £55 with fast worldwide digital delivery.",
    keywords: "virtual staging UK, virtual staging, property virtual staging, virtual home staging UK, virtual staging services, sell property faster, estate agent virtual staging, property marketing UK, Rightmove virtual staging",
  },
  "/virtual-staging-uk": {
    title: "Virtual Staging UK from £55 | 48hr Delivery",
    description: "Transform empty property photos into buyer-ready spaces. Virtual staging for estate agents, developers and sellers across the UK. 48-hour delivery, no subscription.",
    keywords: "virtual staging UK, virtual staging services, property virtual staging UK, virtual home staging, digital staging, empty room staging, virtual staging for estate agents, virtual staging cost UK",
  },
  "/3d-property-rendering-uk": {
    title: "3D Property Rendering UK | CGI Visualisation for Developers",
    description: "Photorealistic 3D property renders for UK developers. Exterior and interior CGI visualisations for off-plan sales, planning applications and marketing brochures.",
    keywords: "3D property renders UK, 3D property rendering, architectural visualisation UK, property CGI, exterior renders, interior renders, off-plan marketing, 3D house renders",
  },
  "/order": {
    title: "Order Virtual Staging | Upload Photos & Checkout | The Secret Seller",
    description: "Order virtual staging in 3 simple steps. Upload your empty room photos, choose your style, and checkout. From £55 per image with 48-hour delivery.",
    keywords: "order virtual staging, buy virtual staging UK, virtual staging upload, virtual staging checkout",
  },
  "/services": {
    title: "Property Marketing Services UK | Virtual Staging & 3D Renders",
    description: "Professional property marketing services for UK estate agents and developers. Virtual staging from £55 and 3D renders. Fast turnaround.",
    keywords: "property marketing services UK, virtual staging services, 3D renders, estate agent services UK",
  },
  "/blog": {
    title: "Property Marketing Insights | Virtual Staging Tips & Guides | The Secret Seller",
    description: "Expert insights on virtual staging, property marketing and selling property faster in the UK. Tips for estate agents, developers and landlords.",
    keywords: "virtual staging blog, property marketing tips, estate agent guides, sell property faster, virtual staging UK tips",
  },
  "/virtual-staging-estate-agents": {
    title: "Virtual Staging for Estate Agents | The Secret Seller",
    description: "Professional virtual staging for UK estate agents. Turn empty listings into buyer-ready homes in 48 hours. From £55 per image.",
    keywords: "virtual staging estate agents, virtual staging for estate agents UK, property staging estate agents, estate agent virtual staging",
  },
  "/how-to-sell-empty-property": {
    title: "How to Sell an Empty Property | Virtual Staging UK | The Secret Seller",
    description: "Empty properties struggle to sell. Learn how virtual staging transforms empty rooms into buyer-ready spaces and helps achieve faster sales.",
    keywords: "sell empty property, how to sell empty property, empty property staging, vacant property staging UK",
  },
  "/do-staged-properties-sell-faster": {
    title: "Do Virtually Staged Properties Sell Faster? | The Secret Seller",
    description: "Research shows virtually staged properties sell up to 73% faster with 40% more portal clicks. See the evidence.",
    keywords: "do staged properties sell faster, virtual staging results, virtual staging statistics, staging increase property value",
  },
  "/virtual-staging-vs-physical-staging": {
    title: "Virtual Staging vs Physical Staging | The Secret Seller",
    description: "Virtual staging from £55 per image vs £2,000+ for physical staging. Compare cost, speed, quality and results.",
    keywords: "virtual staging vs physical staging, home staging comparison, virtual staging cost UK, physical staging cost",
  },
  "/property-marketing-new-builds": {
    title: "Property Marketing for New Build Developments | 3D Renders | The Secret Seller",
    description: "3D renders and virtual staging for UK property developers. Market off-plan developments with photorealistic CGI.",
    keywords: "property marketing new builds, 3D renders developers UK, off-plan marketing, new build CGI renders",
  },
  "/virtual-staging-roi-calculator": {
    title: "Virtual Staging ROI Calculator | The Secret Seller",
    description: "Calculate the return on investment from virtual staging. Enter your property value, expected sale price and number of rooms to see your potential uplift.",
    keywords: "virtual staging ROI, virtual staging calculator, staging cost calculator, property staging return on investment",
  },
};

export default function PageSEO({ path }) {
  const seo = SEO_DATA[path] || SEO_DATA["/"];
  const canonicalPath = path === "/" ? "/" : path;
  const canonicalUrl = `${PROD_DOMAIN}${canonicalPath}`;

  return (
    <Helmet>
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      <meta name="keywords" content={seo.keywords} />
      <link rel="canonical" href={canonicalUrl} />
      <meta property="og:title" content={seo.title} />
      <meta property="og:description" content={seo.description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:type" content="website" />
      <meta property="og:image" content="https://www.thesecretseller.co.uk/og-image.jpg" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:description" content={seo.description} />
    </Helmet>
  );
}
